module.exports = __webpack_public_path__ + "img/logo-light.73342c25.svg";